// src/admin/components/Topbar.jsx
import React from "react";
import "./Topbar.css"; // Import CSS file

const Topbar = ({ toggleSidebar }) => {
  const handleLogout = () => {
    localStorage.clear(); // Clear all data (Token, Role, Permissions, etc.)
    window.location.href = "/admin/login";
  };

  const adminName = localStorage.getItem("adminName") || "Administrator";

  return (
    <div className="admin-topbar">
      <div className="topbar-left" style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
        <button 
          className="mobile-menu-btn" 
          onClick={toggleSidebar}
          style={{ 
            background: 'none', border: 'none', fontSize: '1.5rem', 
            cursor: 'pointer', display: 'none', padding: 0 
          }}
        >
          ☰
        </button>
        <h3>Overview</h3>
      </div>
      <div className="topbar-right">
        <div className="admin-profile">
          <span className="admin-name">{adminName}</span>
          <div className="admin-avatar" style={{ width: '35px', height: '35px', borderRadius: '50%', background: '#f3f6f9', display: 'flex', alignItems: 'center', justifySelf: 'center', textAlign: 'center', justifyContent: 'center', fontSize: '1rem' }}>
            👤
          </div>
        </div>
        <button className="logout-btn" onClick={handleLogout}>Logout</button>
      </div>
    </div>
  );
};

export default Topbar;
